module.exports = __webpack_public_path__ + "img/logo-ed-palmira.aa12eb9d.svg";